module.exports = __webpack_public_path__ + "img/9_120.64605828.png";